"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortItems = void 0;
var types_1 = require("@caddigital/sok-reducers/lib/types");
var list_1 = require("types/list");
var utils_1 = require("./utils");
var sortItems = function (data) {
    var key = data.orderByOptions.orderBy;
    var column = data.columns[key];
    var order = data.orderByOptions.order === types_1.ASC ? 1 : -1;
    return function (a, b) {
        switch (column === null || column === void 0 ? void 0 : column.type) {
            case list_1.ListColumnType.text: {
                var at = (0, utils_1.mapLocalization)(a[key]);
                var bt = (0, utils_1.mapLocalization)(b[key]);
                return at.localeCompare(bt, undefined, utils_1.compareOpts) * order;
            }
            case list_1.ListColumnType.number: {
                return Number(b[key]) - Number(a[key]) * order;
            }
            default:
                return 0;
        }
    };
};
exports.sortItems = sortItems;
